// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  getDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
  deleteDoc,
} from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCN-PgfSV6Sz_CFpDNf-sA1MVdrC722Xkw",
  authDomain: "iou-hub-9d38f.firebaseapp.com",
  projectId: "iou-hub-9d38f",
  storageBucket: "iou-hub-9d38f.firebasestorage.app",
  messagingSenderId: "997115613217",
  appId: "1:997115613217:web:dfbf045b2b918d4042d360",
  measurementId: "G-E7HRBX67YN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Get a list of cities from your database
export const GetIouItemInfo = async (itemId) => {
  const iouLinkCol = doc(db, "iouLinks", itemId);
  const iouLinkSnapshot = await getDoc(iouLinkCol);
  const iouLinkList = iouLinkSnapshot.data();
  if (!iouLinkList) {
    return null;
  }
  const itemCol = doc(db, "iou", iouLinkList?.iouId);
  const itemSnapshot = await getDoc(itemCol);
  const itemList = itemSnapshot.data();
  return itemList;
};

export const GetRewardInfo = async (userId) => {
  const q = query(
    collection(db, "rewards"),
    where("userId", "==", userId),
    where("active", "==", true)
  );
  const rewardSnapshot = await getDocs(q);
  const rewardList = rewardSnapshot.docs.map((doc) => doc.data());
  return rewardList[0];
};

export const GetShareItemInfo = async (itemId) => {
  const itemCol = doc(db, "shareItem", itemId);
  const itemSnapshot = await getDoc(itemCol);
  const requestInfo = itemSnapshot.data();
  if (!requestInfo) {
    return null;
  }
  const itemInfoCol = doc(db, "items", requestInfo.itemId);
  const itemInfoSnapshot = await getDoc(itemInfoCol);
  const itemInfoList = itemInfoSnapshot.data();
  requestInfo.item = itemInfoList;
  return requestInfo;
};

export const GetUserInfo = async (userId) => {
  const userCol = doc(db, "users", userId);
  const userSnapshot = await getDoc(userCol);
  const userInfo = userSnapshot.data();
  return userInfo;
};

export const GetReportInfo = async (reportId) => {
  const reportCol = doc(db, "reports", reportId);
  const reportSnapshot = await getDoc(reportCol);
  const reportInfo = reportSnapshot.data();
  return reportInfo;
};

export const DeleteReport = async (reportId) => {
  const reportCol = doc(db, "reports", reportId);
  await deleteDoc(reportCol);
};
